import React, { useEffect, useState } from 'react';
import {
  Flex,
  TableContainer,
  Table,
  Heading,
  Thead,
  Tr,
  Th,
  Tbody,
  Spinner,
  useDisclosure,
  Text,
  Button,
} from '@chakra-ui/react';
import { useQuery } from '@apollo/client';
import Pagination from '../../../../components/Pagination';
import { GET_PAGES } from '../../../../graphQL/queries';
import { Page } from '../../../../shared/models/page';
import { Pagination as PagePagination } from '../../../../shared/models/pagination';
import Item from './Item';
import DynamicPageModal from '../../components/DynamicShowcaseModal';
import { PageType } from '../../../MenuItem/types';

const List: React.FC = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { data, refetch, loading } = useQuery<{
    pagesPaginated: PagePagination<Page>;
  }>(GET_PAGES, {
    variables: {
      limit: 12,
      showcase_only: true,
    },
  });
  const [pages, setPages] = useState<Page[]>([]);
  const [pageToEdit, setPageToEdit] = useState<any | null>(null);

  useEffect(() => {
    setPages(data?.pagesPaginated.data || []);
  }, [data?.pagesPaginated.data]);
  return (
    <Flex
      flexDir="column"
      w="100%"
      p={8}
      overflow="auto"
      bg="#F9F9F9"
      css={{
        '&::-webkit-scrollbar': {
          width: '6px',
        },
        '&::-webkit-scrollbar-track': {
          width: '6px',
        },
        '&::-webkit-scrollbar-thumb': {
          background: '#469BFF',
          borderRadius: '24px',
        },
      }}
    >
      <DynamicPageModal
        isOpen={isOpen}
        ItemToEdit={pageToEdit}
        onClose={() => {
          onClose();
          setPageToEdit(null);
        }}
        onCreated={(page: any) => {
          setPages(state => [...state, page]);
        }}
        onEdited={(page: any) => {
          setPages((state: any) => {
            return state.map((statePage: any) => {
              if (statePage.id !== page.id) return statePage;
              return page;
            });
          });
        }}
      />
      <Heading mb="48px" color="#469BFF" fontFamily="Poppins">
        Vitrines Dinâmicas
      </Heading>
      <Button
        textAlign="center"
        ml="4"
        fontWeight="300"
        fontFamily="Poppins"
        position="relative"
        padding="10px 0 10px 0"
        width="200px"
        border="0px"
        aria-label="create_page"
        rounded="md"
        colorScheme="brand"
        onClick={() => onOpen()}
      >
        Nova Vitrine
      </Button>
      <Flex
        position="relative"
        flexDir="column"
        bg="#F9F9F9"
        p={4}
        mt={3}
        borderRadius={6}
      >
        <TableContainer>
          <Table variant="simple">
            <Thead>
              <Tr>
                <Th textColor="#469BFF" fontFamily="Poppins">
                  Página
                </Th>
                {/* <Th textColor="#469BFF" fontFamily="Poppins">
                  Slug
                </Th> */}
                <Th textColor="#469BFF" fontFamily="Poppins">
                  Query Vtex
                </Th>
                <Th textColor="#469BFF" fontFamily="Poppins">
                  AÇÕES
                </Th>
              </Tr>
            </Thead>
            <Tbody>
              {pages ? (
                // eslint-disable-next-line array-callback-return, consistent-return
                pages.map((page: PageType) => {
                  if (page?.vtex_query) {
                    return (
                      <Item
                        key={page?.id}
                        page={page}
                        onDelete={id => {
                          setPages(state =>
                            state.filter((oldPage: any) => oldPage?.id !== id),
                          );
                        }}
                        onEditClick={(onEditedData: any) => {
                          setPageToEdit(onEditedData);
                          onOpen();
                        }}
                      />
                    );
                  }
                })
              ) : (
                <Text color="red">Não foi encontrado nenhuma página</Text>
              )}
            </Tbody>
          </Table>
        </TableContainer>
        <Flex justifyContent="center" mt="4">
          <Pagination
            current={data?.pagesPaginated.page || 1}
            perPage={data?.pagesPaginated.limit || 10}
            total={data?.pagesPaginated.total || 0}
            onPageChange={page => {
              if (data && page > data.pagesPaginated.totalPages) return;
              refetch({ page });
            }}
          />
        </Flex>
        {loading && (
          <Flex
            position="absolute"
            align="center"
            justify="center"
            top="50%"
            left="50%"
          >
            <Spinner color="brand.500" size="xl" />
          </Flex>
        )}
      </Flex>
    </Flex>
  );
};

export default List;
